import { render, staticRenderFns } from "./callPackageType.vue?vue&type=template&id=05b72a86&scoped=true&"
import script from "./callPackageType.vue?vue&type=script&lang=js&"
export * from "./callPackageType.vue?vue&type=script&lang=js&"
import style0 from "./callPackageType.vue?vue&type=style&index=0&id=05b72a86&prod&lang=css&"
import style1 from "./callPackageType.vue?vue&type=style&index=1&id=05b72a86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b72a86",
  null
  
)

export default component.exports